<script setup>
import { onMounted, ref } from 'vue'
import { getPhysicalStations } from '../api.js'
import PartnerApiClientsPanel from '../components/platform/PartnerApiClientsPanel.vue'

const stations = ref([])
onMounted(async () => { stations.value = (await getPhysicalStations()).stations ?? [] })
</script>

<template><section class="platform-page"><PartnerApiClientsPanel :stations="stations" /></section></template>
